module.exports = __webpack_public_path__ + "static/media/darkmode.75e7307a.png";